// /src/pdf/builders/ads/buildDoc.js
// Билдер docDefinition для отчёта Ads (pdfmake)

export function buildAdsDoc({
  t, shortcode, stationName, date, blocks, fmtNumber, locale, logoDataUrl,
  serviceName
}) {
  const rows = [
    [
      { text: t('ads.table.start'), style: 'th' },
      { text: t('ads.table.end'), style: 'th' },
      { text: t('ads.table.clips'), style: 'th' },
      { text: t('ads.table.listeners'), style: 'th', alignment: 'right' },
    ],
    ...(blocks || []).map((b) => ([
      { text: b.start?.slice(0, 8) || '', alignment: 'left' },
      { text: b.end?.slice(0, 8) || '', alignment: 'left' },
      { text: (b.clips || []).join('\n'), alignment: 'left' },
      { text: fmtNumber(b.listeners || 0, locale), alignment: 'right' },
    ])),
  ];

  const total = (blocks || []).reduce((acc, b) => acc + (b.listeners || 0), 0);
  const stationTitle = stationName || shortcode || '';
  const serviceTitle = serviceName || (t && t('ads.title')) || '';

  // собираем контент по шагам, чтобы опционально вставить логотип и подпись
  const content = [];
  if (logoDataUrl) {
    content.push({ image: logoDataUrl, width: 140, margin: [0, 0, 0, 10] });
  }
  content.push(
    ...(serviceTitle ? [{ text: serviceTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    ...(stationTitle ? [{ text: stationTitle, style: 'h1', margin: [0, 0, 0, 4] }] : []),
    {
      margin: [0, 0, 0, 6],
      fontSize: 10,
      color: '#666',
      stack: [
        `${t('ads.date')}: ${date}`,
        `${stationTitle || ''}`,
      ],
    },
    {
      text: (t && t('pdf.made_on')) || 'Report made on Radiomonitor.net',
      fontSize: 10,
      color: '#666',
      margin: [0, 0, 0, 10]
    }
  );

  const madeOnText = (t && t('pdf.made_on')) || 'Report made on Radiomonitor.net';

  return {
    pageSize: 'A4',
    pageMargins: [24, 28, 24, 36],
    footer: (current, totalPages) => ({
      margin: [24, 0, 24, 12],
      fontSize: 9,
      columns: [
        { text: `${madeOnText} • ${new Date().toLocaleString()}`, alignment: 'left' },
        { text: `${current} / ${totalPages}`, alignment: 'right' },
      ],
    }),
    content: [
      ...content,
      {
        table: {
          headerRows: 1,
          widths: ['auto', 'auto', '*', 'auto'],
          body: rows,
        },
        layout: {
          fillColor: (rowIndex) => (rowIndex === 0 ? '#f0f0f0' : null),
          hLineColor: '#e0e0e0',
          vLineColor: '#e0e0e0',
        },
      },
      {
        margin: [0, 8, 0, 0],
        columns: [
          { text: t('ads.table.listeners') + ':', width: 'auto', style: 'totalLabel' },
          { text: fmtNumber(total, locale), alignment: 'right', style: 'totalValue' },
        ],
      }
    ],
    styles: {
      h1: { fontSize: 18, bold: true },
      th: { bold: true },
      totalLabel: { fontSize: 11, bold: true },
      totalValue: { fontSize: 12, bold: true },
    },
  };
}
